import supabaseClient from "@/api/supabaseClient";
import { SupabaseClient } from "@supabase/supabase-js";
import { useMutation } from "@tanstack/react-query";
import { queryClient } from "@/main.tsx";
import type { UpdateAccountRequest } from "$/requests/UpdateAccountRequest.ts";
import userRepository from "@/api/repositories/userRepository/UserRepository.ts";

const useUpdateUserAccount = () => {
  const client = supabaseClient;

  return useMutation({
    mutationFn: (request: UpdateAccountRequest) =>
      updateUserAccount(client, request),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["user"] });
      await supabaseClient.auth.refreshSession();
    },
  });
};

export default useUpdateUserAccount;

async function updateUserAccount(
  client: SupabaseClient,
  request: UpdateAccountRequest,
) {
  const updateData: { email?: string; password?: string } = {};

  if (request.email) {
    updateData.email = request.email;
  }

  if (request.password) {
    updateData.password = request.password;
  }

  const { data, error } = await client.auth.updateUser(updateData);

  if (error) {
    throw new Error(error.message);
  }

  const { error: errorUpdateUser } = await userRepository.update(
    {
      name: request.name,
      preferred_name: request.preferred_name,
      email: request.email,
      last_name: request.last_name,
    },
    {
      id: data.user?.id,
    },
  );

  if (errorUpdateUser) {
    throw new Error(errorUpdateUser.message);
  }

  return data;
}
